#import "./NotesEntityFields.graphql"

query TravelerNotes($id: UUID!) {
  traveler(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
